
import React, { useEffect, useState } from 'react';
import previousInactive from '../../../assests/arrow_back_grey.png'
import previousActive from '../../../assests/arrow_back.png'
import nextInactive from '../../../assests/arrow_forward_grey.png'
import nextActive from '../../../assests/arrow_forward.png'
import { authorizedHttpPost } from '../../../api/httpCalls';
import urls from '../../../api/urls.json'
import Loader from '../../Loader';

const About2 = ({ reviews, page, totalPages, handlePageChangeAbountOne, afterSave }) => {
    const reviewData = reviews[0] || {}
    const [reviewText, setReviewText] = useState('')
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setReviewText(reviewData.text)
    }, [reviews])

    const handlePageChange = (type) => {
        if (type === 'previous') {
            if (page > 1) {
                handlePageChangeAbountOne(page - 1)
            }
        } else {
            if (page !== totalPages) {
                handlePageChangeAbountOne(page + 1)
            }
        }
    }

    const handleActionButton = async (type) => {
        let url, data;
        data = { "review_id": reviewData.review_id, "text": reviewText }
        setIsLoading(true);
        if (type === 'dismiss') {
            url = urls.POST_REVIEW_DISMISS_INDIVIDUAL
        }
        else if (type === 'warn' || type === 'save') {
            url = urls.POST_REVIEW_INDIVIDUAL
        }

        data['send_email'] = type === 'warn' ? true : false;

        let response = await authorizedHttpPost(url, data)
        if (response.status) {
            afterSave()
        }
        setIsLoading(false);
    };

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'ArrowLeft') {
                handlePageChange('previous')
            } else if (event.key === 'ArrowRight') {
                handlePageChange('next')
            }
        };
        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    });

    return (
        <div className='aboutTwoDiv'>
            {isLoading && <Loader />}
            <div>
                <div>
                    <span className='biosName floatLeft'>{reviewData.name} / </span>
                    <span className='biosName floatLeft'>{reviewData.profile_state}</span>
                    <span className='biosName marginRight60'>{reviewData.ref}</span>
                </div>
                <div className='spamDiv'>

                    {reviewData.keywords && reviewData.keywords.map(text => {
                        return (
                            <span className='biosName biosSpam floatLeft'>
                                {' '}
                                {text} /{' '}
                            </span>
                        );
                    })}
                </div>
                <textarea className='textAreaStyles'
                    value={reviewText}
                    onChange={e => {
                        setReviewText(e.target.value);
                    }}
                />
            </div>
            {
                reviews.length > 0 &&
                <div className='about2PageDirection'>
                    {page === 1 ? <img src={previousInactive} className='arrowIcon marginTop16' onClick={() => handlePageChange('previous')} /> : <img src={previousActive} onClick={() => handlePageChange('previous')} className='arrowIcon marginTop16' />}
                    <button className='buttonStyles dismissButton' onClick={() => handleActionButton('dismiss')}>Dismiss</button>
                    <button className='buttonStyles warnButton' onClick={() => handleActionButton('warn')}>Warn</button>
                    <button className='buttonStyles saveButtonBios' onClick={() => handleActionButton('save')}>Save</button>
                    {page === totalPages ? <img src={nextInactive} className='arrowIcon marginTop16' onClick={() => handlePageChange('next')} /> : <img src={nextActive} onClick={() => handlePageChange('next')} className='arrowIcon marginTop16' />}
                </div>
            }
        </div>
    );
};

export default About2;
